import React, { useState, useEffect, Fragment } from "react";
import { Button, Header, Icon, Modal } from "semantic-ui-react";
import { useSelector, useDispatch } from "react-redux";
import Tooltip from "@material-ui/core/Tooltip";
import { fileRequest } from "../../store/action/fileEdiRequest";
import { fetchEdidata } from "../../store/action/ediResponse";
import { clearSelectedEdiRecords } from "../../store/action/selectedRecords";
import { clearTokenResponse } from "../../store/action/getFileToken";
import {
  clearEdiResponseRecords,
  clearEdiRequestRecords,
} from "../../store/action/respRecordsClear";
import { setFlagforPopup } from "../../store/action/ediReqRecords";
import { GetfileToken } from "../../store/action/getFileToken";
import CircularProgress from "@material-ui/core/CircularProgress";

function FileRecord(props) {
  const hmrcValues = [
    { id: 0, value: "No" },
    { id: 1, value: "Yes" },
  ];
  const cbsaValues = [
    { id: false, value: "No" },
    { id: true, value: "Yes" },
  ];
  const [open, setOpen] = useState(false);
  const [dimmer, setDimmer] = useState(undefined);
  const [fileHMRC, setfileHMRC] = useState(null);
  const [fileCBSA, setfileCBSA] = useState(null);
  const [showfileCbsaError, setshowfileCbsaError] = useState(false);
  const [showfileHmrcError, setshowfileHmrcError] = useState(false);
  const [pass, setPass] = useState("");
  const [passwordEmpty, setpasswordEmpty] = useState(false);
  const [wrongpassword, setwrongPassword] = useState(false);
  const [checked, setChecked] = useState(false);
  const [emailErr, setEmailErr] = useState(false);
  const [reasonErr, setreasonErr] = useState(false);
  const [domainErr, setDomainErr] = useState(false);
  const [emailErrDesc, setemailErrDesc] = useState("");
  const [token, setToken] = useState("");
  const [tokenErr, setTokenErr] = useState(false);
  const [tokenErrDesc, setTokenErrDesc] = useState("");

  const [size, setSize] = useState(undefined);
  const [email, setEmail] = useState("");
  const [reason, setReason] = useState("");
  const shipmentID = useSelector(
    (state) =>
      window.shipmentId ||
      state.isf?.shipmentID ||
      props.shipmentId ||
      state.edi?.edidata?.eventMessage?.shipmentid
  );
  const selectedRow = useSelector((state) => state.rowSelected?.selectedRow);
  const ediRecordFiled = useSelector((state) => state.ediRecordFiled.loading);
  const usFormType =
    useSelector((state) => state.formTypeReducer?.usFormType) || "ES";
  const documentType =
    useSelector((state) => state.rowSelected?.selectedRow?.documentType) || "";
  const country =
    useSelector(
      (state) => state.isf?.currentJobData.shipment.countryOfBusiness
    ) ||
    props.countryOfBusiness ||
    window.shipmentCountry;

  const PopupRecords = useSelector((state) => state.ediReq?.popupRecords);
  const getTokenLoader = useSelector((state) => state.fileTokenReducer.loading);
  const tokenGeneratedCode = useSelector(
    (state) => state.fileTokenReducer.token?.eventMessage?.code
  );

  const requestFiledResponse = useSelector(
    (state) => state.ediRecordFiled?.recordFiled?.eventMessage?.fieldmessage
  );

  const dispatch = useDispatch();

  const onModalOpen = () => {
    setOpen(true);
    setDimmer("blurring");
    setSize("small");
  };
  const onModalClose = () => {
    setpasswordEmpty(false);
    setwrongPassword(false);
    setPass("");
    setChecked(false);
    setfileHMRC(null);
    setEmailErr("");
    setEmail("");
    setReason("");
    setreasonErr("");
    setemailErrDesc("");
    setTokenErr(false);
    setToken("");
    dispatch(clearTokenResponse());
    setfileCBSA(null);
    setshowfileHmrcError(false);
    setshowfileCbsaError(false);
    setOpen(false);
  };
  const password = "12345";

  const tokenSubmitSuccess = (requestFiledResponse) => {
    if (requestFiledResponse && requestFiledResponse === "Token Expired") {
      setTokenErr(true);
      setTokenErrDesc("Token Expired");
      return;
    }

    if (requestFiledResponse && requestFiledResponse === "Invalid Token") {
      setTokenErr(true);
      setTokenErrDesc("Invalid Token");
      return;
    }

    if (
      requestFiledResponse !== "Token Expired" ||
      requestFiledResponse !== "Invalid Token"
    ) {
      dispatch(clearSelectedEdiRecords());
      dispatch(clearEdiResponseRecords());
      dispatch(clearEdiRequestRecords());
      dispatch(setFlagforPopup(false));
      dispatch(clearTokenResponse());
      dispatch(fetchEdidata(shipmentID, country, usFormType));
      setEmailErr("");
      setEmail("");
      setReason("");
      setreasonErr("");
      setemailErrDesc("");
      setTokenErr(false);
      setToken("");
      setOpen(false);
    }
  };

  const getRequestTime = () => {
    if (selectedRow.requestTime) {
      return 1;
    } else {
      return 0;
    }
  };

  const handleGB = async () => {
    let isValidated = true;

    if (token.length < 1) {
      isValidated = false;
      setTokenErr(true);
      setTokenErrDesc("Token is required !");
    }

    if (isValidated) {
      let newRequestFiledResponse = await dispatch(
        fileRequest(
          selectedRow,
          getRequestTime(),
          shipmentID,
          PopupRecords,
          country,
          fileHMRC,
          email,
          token,
          null,
          reason
        )
      );

      tokenSubmitSuccess(newRequestFiledResponse.eventMessage.msg);
    }
  };
  const handleUS = async () => {
    let isValidated = true;

    if (token.length < 1) {
      isValidated = false;
      setTokenErr(true);
      setTokenErrDesc("Token is required !");
    }

    if (isValidated) {
      let newRequestFiledResponse = await dispatch(
        fileRequest(
          selectedRow,
          getRequestTime(),
          shipmentID,
          PopupRecords,
          country,
          fileHMRC,
          email,
          token,
          null,
          reason,
          usFormType,
          documentType
        )
      );

      tokenSubmitSuccess(newRequestFiledResponse.eventMessage.msg);
    }
  };
  const handleCA = async () => {
    let isValidated = true;

    if (token.length < 1) {
      isValidated = false;
      setTokenErr(true);
      setTokenErrDesc("Token is required !");
    }

    if (isValidated) {
      let newRequestFiledResponse = await dispatch(
        fileRequest(
          selectedRow,
          getRequestTime(),
          shipmentID,
          PopupRecords,
          country,
          fileHMRC,
          email,
          token,
          fileCBSA,
          reason
        )
      );

      tokenSubmitSuccess(newRequestFiledResponse.eventMessage.msg);
    }
  };
  const onSubmit = (event) => {
    event.preventDefault();
    switch (country) {
      case "GB":
        handleGB();
        break;
      case "US":
        handleUS();
        break;
      case "CA":
        handleCA();
        break;
      default:
        break;
    }
  };

  const onCloseModal = () => {
    setpasswordEmpty(false);
    setwrongPassword(false);
    setPass("");
    setChecked(false);
    setfileHMRC(null);
    setshowfileHmrcError(false);
    setEmailErr("");
    setEmail("");
    setReason("");
    setreasonErr("");
    setemailErrDesc("");
    setTokenErr(false);
    setToken("");
    dispatch(clearTokenResponse());
    setfileCBSA(null);
    setshowfileCbsaError(false);
    setOpen(false);
  };
  const onchangehandler = (e) => {
    setpasswordEmpty(false);
    setwrongPassword(false);
    setPass(e.target.value);
  };
  const InputEvent = (e) => {
    setshowfileHmrcError(false);
    const hmrcValue = e.target.value;
    setfileHMRC(Number(hmrcValue));
  };
  const InputEventCBSA = (e) => {
    setshowfileCbsaError(false);
    const CbsaValue = e.target.value;
    const FinalVal =
      CbsaValue === "false" ? !Boolean(CbsaValue) : Boolean(CbsaValue);
    setfileCBSA(FinalVal);
  };

  const validateEmail = (email) => {
    var re =
      /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    if (re.test(email)) {
      //Email valid. Procees to test if it's from the right domain (Second argument is to check that the string ENDS with this domain, and that it doesn't just contain it)
      if (
        email.indexOf(
          "@klearnow.com",
          email.length - "@klearnow.com".length
        ) !== -1
      ) {
        //VALID
        return true;
      } else {
        return "InvalidDomain";
      }
    } else {
      return "InvalidFormat";
    }
  };

  const generateTokenAgain = () => {
    dispatch(clearTokenResponse());
    setTokenErr(false);
    setTokenErrDesc("");
    setfileHMRC(null);
    setfileCBSA(null);
    setToken("");
  };

  const Submit_get_Token = async (shipmentID, email, requestid, reason) => {
    let isValidated = true;
    if (country === "GB") {
      if (fileHMRC === null) {
        isValidated = false;
        setshowfileHmrcError(true);
      }
    }
    if (country === "CA") {
      if (fileCBSA === null) {
        isValidated = false;
        setshowfileCbsaError(true);
      }
    }
    if (email.length <= 0) {
      isValidated = false;
      setemailErrDesc("Email is required !");
      setEmailErr(true);
    }

    if (email) {
      const emailisValid = validateEmail(email);
      if (emailisValid === "InvalidDomain") {
        isValidated = false;
        setemailErrDesc("Only @klearnow domain is supported !");
        setEmailErr(true);
      }
      if (emailisValid === "InvalidFormat") {
        isValidated = false;
        setemailErrDesc("Invalid email format !");
        setEmailErr(true);
      }
    }
    // if(email){

    // }
    if (reason.length <= 10) {
      isValidated = false;
      setreasonErr(true);
    }
    if (isValidated) {
      await dispatch(GetfileToken(shipmentID, email, requestid, reason));
    }
  };

  return (
    <Fragment>
      <Modal
        onClose={onModalClose}
        onOpen={onModalOpen}
        open={open}
        dimmer={dimmer}
        size={size}
        trigger={
          <Tooltip
            title="File Request"
            placement="top"
            arrow
            aria-label="File Request"
          >
            <button className="file-button">File EDI</button>
          </Tooltip>
        }
      >
        <Modal.Content>
          <Modal.Description>
            {selectedRow.requestTime ? (
              <p style={{ fontSize: "15px" }}>
                Your action will create a new request and File that request for
                ShipmentID : <b>{shipmentID}</b>
              </p>
            ) : (
              <p style={{ fontSize: "15px" }}>
                Your action will File Request for requestID :{" "}
                <b>{selectedRow.requestid}</b> of ShipmentID :{" "}
                <b>{shipmentID}</b>
              </p>
            )}
            <br />
            {country === "GB" && tokenGeneratedCode !== 200 && (
              <Fragment>
                <br />
                <br />
                <span
                  style={{
                    display: "block",
                    fontFamily: "monospace",
                    font: "icon",
                  }}
                >
                  File with HMRC :
                  <select
                    style={{ marginLeft: "10px", width: "40%" }}
                    onChange={(e) => InputEvent(e)}
                    defaultValue={"DEFAULT"}
                  >
                    <option value="DEFAULT" disabled>
                      Please select one
                    </option>
                    {hmrcValues.map((dt, i) => (
                      <option key={i} value={dt.id}>
                        {dt.value}
                      </option>
                    ))}
                  </select>
                </span>
              </Fragment>
            )}
            {showfileHmrcError && (
              <span style={{ color: "red", fontFamily: "monospace" }}>
                File with hmrc is required !
              </span>
            )}
            {country === "CA" && tokenGeneratedCode !== 200 && (
              <Fragment>
                <br />
                <br />
                <span
                  style={{
                    display: "block",
                    fontFamily: "monospace",
                    font: "icon",
                  }}
                >
                  File with CBSA :
                  <select
                    style={{ marginLeft: "10px", width: "40%" }}
                    onChange={(e) => InputEventCBSA(e)}
                    defaultValue={"DEFAULT"}
                  >
                    <option value="DEFAULT" disabled>
                      Please select one
                    </option>
                    {cbsaValues.map((dt, i) => (
                      <option key={i} value={dt.id}>
                        {dt.value}
                      </option>
                    ))}
                  </select>
                </span>
              </Fragment>
            )}
            {showfileCbsaError && (
              <span style={{ color: "red", fontFamily: "monospace" }}>
                File with Cbsa is required !
              </span>
            )}
            <br />
            {tokenGeneratedCode !== 200 && (
              <div style={{ display: "inline-grid", width: "100%" }}>
                <span>Please enter your email : </span>
                <input
                  style={{ fontSize: "18px", fontFamily: "monospace" }}
                  value={email}
                  onChange={(e) => {
                    setEmail(e.target.value);
                    setEmailErr(false);
                    setDomainErr(false);
                  }}
                  type="text"
                />
                {emailErr && (
                  <span
                    style={{
                      color: "red",
                      display: "block",
                      fontFamily: "monospace",
                    }}
                  >
                    {emailErrDesc}
                  </span>
                )}

                <br />

                <textarea
                  style={{
                    height: "70px",
                    fontFamily: "monospace",
                    fontSize: "18px",
                  }}
                  value={reason}
                  placeholder="Reason For Filing"
                  onChange={(e) => {
                    setReason(e.target.value);
                    setreasonErr(false);
                  }}
                />
                {reasonErr && (
                  <span
                    style={{
                      color: "red",
                      display: "block",
                      fontFamily: "monospace",
                    }}
                  >
                    Reason should contain atleast 10 chars.
                  </span>
                )}
                <br />
                <button
                  style={{
                    marginLeft: "40%",
                    marginRight: "44%",
                    color: "black",
                    fontFamily: "outline-icons",
                    cursor: "pointer",
                  }}
                  disabled={getTokenLoader}
                  onClick={() =>
                    Submit_get_Token(
                      shipmentID,
                      email,
                      selectedRow.requestid,
                      reason
                    )
                  }
                >
                  GET TOKEN
                </button>
                {getTokenLoader && (
                  <CircularProgress
                    style={{ marginLeft: "45%" }}
                    color="secondary"
                  />
                )}
              </div>
            )}

            {/* {tokenGeneratedCode === 200 &&  */}
            {tokenGeneratedCode === 200 && (
              <Fragment>
                <div className="alert-file-token">
                  <span style={{ fontFamily: "monospace", fontWeight: "800" }}>
                    Token sent successfully to your email id :{" "}
                    {email.toUpperCase()} &#10003;
                  </span>
                </div>
                <label className="label-en-token">Please enter token : </label>
                <input
                  value={token}
                  onChange={(e) => {
                    setToken(e.target.value);
                    setTokenErr(false);
                  }}
                  type="text"
                  className="sbt-token"
                />
                {tokenErr && (
                  <span
                    style={{
                      color: "red",
                      display: "block",
                      fontFamily: "monospace",
                      textAlign: "center",
                    }}
                  >
                    {tokenErrDesc}
                  </span>
                )}
                <button onClick={generateTokenAgain} className="gt-tk-again">
                  Token expired / Wrong email / Didn't receive token ?
                </button>
              </Fragment>
            )}

            {/* } */}
          </Modal.Description>
          <Header>Are you sure?</Header>
        </Modal.Content>
        <Modal.Actions>
          <Button
            disabled={ediRecordFiled ? true : false}
            color="red"
            onClick={onCloseModal}
          >
            Nope
          </Button>

          <Button
            disabled={
              ediRecordFiled ? true : tokenGeneratedCode !== 200 ? true : false
            }
            content="Yes"
            labelPosition="right"
            icon="checkmark"
            onClick={onSubmit}
            positive
          />
        </Modal.Actions>
      </Modal>
    </Fragment>
  );
}

export default FileRecord;
